import * as React from 'react';
import { Form_NumberInputProps } from '../../../../../../react-commons/components/form/inputs/Form_NumberInput';
import { IntegerType } from '../../../../../../react-commons/enums/integerType';
import { INTEGER_BOUNDARIES } from '../../../../../../react-commons/schemas/integerSchemas';
import { Inputs } from '../../../../../../react-commons/utils/form/inputs';
import { usePropertyInfo } from '../../../hooks/usePropertyInfo';
import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';

export const Form_PropertyIntegerInput = <T extends object, N extends boolean>({
    readOnly,
    labelOverride,
    propertyValidationInformation: { propertyIdentifier, resourceType, resourceId },
    hideLabel,
    positiveOnly = false,
    integerType = IntegerType.INT,
    min: _min,
    max: _max,
    ...props
}: Omit<Form_NumberInputProps<T, N>, 'allowDecimal' | 'label' | 'labelInfo' | 'severity' | 'helperText'> & {
    labelOverride?: string;
    propertyValidationInformation: PropertyValidationInformation;
    hideLabel?: boolean;
    positiveOnly?: boolean; // TODO make this required?
    integerType?: IntegerType;
}) => {
    const propertyInfo = usePropertyInfo({
        propertyIdentifier,
        resourceType,
        resourceId,
        hideLabel,
        labelOverride,
        readOnly,
    });

    const { MIN: minBoundary, MAX: maxBoundary } = INTEGER_BOUNDARIES[integerType];

    const min = (() => {
        if (_min !== undefined && positiveOnly) {
            return Math.max(minBoundary, _min, 0);
        } else if (_min !== undefined) {
            return Math.max(minBoundary, _min);
        } else if (positiveOnly) {
            return Math.max(minBoundary, 0);
        } else {
            return minBoundary;
        }
    })();
    const max = _max !== undefined ? Math.min(_max, maxBoundary) : maxBoundary;

    return <Inputs.Number
        allowDecimal={false}
        min={min}
        max={max}
        {...propertyInfo}
        {...props}
        helperText={propertyInfo.helperText ? [propertyInfo.helperText] : undefined}
    />;
};
